module.exports = __webpack_public_path__ + "img/026ab40.png";